import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LangContext";
import { t } from "../i18n/translations";

const LOGO = "https://customer-assets.emergentagent.com/job_massage-portal-6/artifacts/g3nld1od_logo_transparent_background.webp";

export const Footer = () => {
  const { lang } = useLang();
  return (
    <footer className="bg-ink text-sand mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img src={LOGO} alt="Ayurveda Aargau" className="h-24 w-auto object-contain" />
          <p className="mt-5 text-sm text-sand/70 max-w-xs leading-relaxed">{t(lang, "footer.tagline")}</p>
          <p className="mt-4 text-sm text-sand/60 max-w-xs leading-relaxed">
            <strong className="text-sand/80 font-normal">Sarmenstorf</strong><br/>
            Obere Feldeggstr. 13<br/>
            5614 Sarmenstorf
          </p>
          <p className="mt-3 text-sm text-sand/60 max-w-xs leading-relaxed">
            <strong className="text-sand/80 font-normal">Rupperswil</strong><br/>
            Aarestrasse 20<br/>
            5102 Rupperswil
          </p>
        </div>
        <div>
          <h4 className="font-display text-lg mb-3">{t(lang, "nav.massagen")}</h4>
          <ul className="space-y-2 text-sm text-sand/70">
            <li><Link to="/massagen" className="hover:text-white">{t(lang, "nav.massagen")}</Link></li>
            <li><Link to="/klangschalen" className="hover:text-white">{t(lang, "nav.klangschalen")}</Link></li>
            <li><Link to="/ernaehrung" className="hover:text-white">{t(lang, "nav.ernaehrung")}</Link></li>
            <li><Link to="/gutscheine" className="hover:text-white">{t(lang, "nav.vouchers")}</Link></li>
            <li><Link to="/booking" className="hover:text-white">{t(lang, "nav.book")}</Link></li>
            <li><Link to="/stressabbau" className="hover:text-white">Stressabbau</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-lg mb-3">{t(lang, "nav.standort")}</h4>
          <ul className="space-y-2 text-sm text-sand/70">
            <li><Link to="/about" className="hover:text-white">{t(lang, "nav.about")}</Link></li>
            <li><Link to="/standort" className="hover:text-white">{t(lang, "nav.standort")}</Link></li>
            <li><a href="mailto:contact@ayurveda-aargau.ch" className="hover:text-white">contact@ayurveda-aargau.ch</a></li>
            <li><a href="mailto:info@ayurveda-aargau.ch" className="hover:text-white">info@ayurveda-aargau.ch</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-sand/10 py-6 text-center text-xs text-sand/50">
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 mb-3">
          <Link to="/datenschutz" className="hover:text-white" data-testid="footer-datenschutz">Datenschutz</Link>
          <span className="text-sand/30">·</span>
          <Link to="/agb" className="hover:text-white" data-testid="footer-agb">AGB</Link>
          <span className="text-sand/30">·</span>
          <Link to="/impressum" className="hover:text-white" data-testid="footer-impressum">Impressum</Link>
        </div>
        © {new Date().getFullYear()} Ayurveda Aargau · {t(lang, "footer.rights")}
      </div>
    </footer>
  );
};
